/* eslint-disable no-debugger */
import React, { useContext } from 'react'

import { ApplicationContext } from 'Context'

import Claims from './Claims'

interface ReturnProps {
  isAuthorized: (claim: Claims) => boolean

  isSystemMaster: () => boolean
}

const usePermissions = (): ReturnProps => {
  const { applicationContext } = useContext(ApplicationContext)
  const userPermissions = applicationContext.usuarioAtual?.permissoes

  const isAuthorized = (claim: Claims) => {
    if (userPermissions?.find((x) => x.id === claim)) {
      return true
    } else {
      return false
    }
  }

  const isSystemMaster = () => {
    if (applicationContext.usuarioAtual?.mestreSistema) return true
    else return false
  }

  return {
    isAuthorized,
    isSystemMaster,
  }
}

export default usePermissions
